import { ChildDiscountsIcon } from 'assets';
import { childrenTexts } from 'consts/text';
import { Child, ChildId, NonNullableObject } from 'types';
import { DiscountsTable } from 'components/templates/discounts/DiscountsTable/DiscountsTable';
import { IconPlus } from '@tabler/icons-react';
import { useParams } from 'react-router-dom';
import { AppButton, ComponentBlockingAppLoader, DetailsFrameBase } from 'components/atoms';
import StaffHTTPService from 'services/HTTPService/staff/StaffHTTPService';
import { useAppQuery } from 'services/reactQuery/useAppQuery';
import { useChildrenDetailsPath } from 'hooks/useChildrenDetailsPath/useChildrenDetailsPath';
import { useChildAbilities } from 'abilities';

import { useNavigateWithState } from 'hooks/useNavigateWithState/useNavigateWithState';

type DiscountsProps = NonNullableObject<Pick<Child, 'status'>>;

export const Discounts = ({ status: childStatus }: DiscountsProps) => {
    const { statefulNavigate } = useNavigateWithState();
    const { childId } = useParams<{ childId: ChildId }>();
    const { getChildrenDetailsPath } = useChildrenDetailsPath();
    const { childAbilities } = useChildAbilities();

    const canManageChildDetails =
        childStatus === 'ACTIVE' && childAbilities.checkIfCanManageChildrenList();

    const {
        data: discountData,
        isFetching,
        isError,
    } = useAppQuery(
        'CHILD_DISCOUNTS',
        [childId],
        () => StaffHTTPService.discounts.getDiscounts(childId as ChildId),
        { refetchOnWindowFocus: false },
    );

    const onAddDiscount = () => {
        if (!childId) {
            return;
        }
        const path = getChildrenDetailsPath('/add-discount', childId);
        statefulNavigate(path);
    };

    return (
        <DetailsFrameBase
            icon={<ChildDiscountsIcon />}
            title={childrenTexts.childDetails.discounts.discounts}
            noFrame
            smallHeaderMargin
        >
            {!!discountData?.length && !isError && (
                <DiscountsTable
                    discounts={discountData}
                    isError={isError}
                    canManageTable={canManageChildDetails}
                />
            )}
            {canManageChildDetails && (
                <AppButton icon={<IconPlus />} onClick={onAddDiscount} marginLeft={0}>
                    {childrenTexts.childDetails.discounts.addDiscount}
                </AppButton>
            )}
            {isFetching && <ComponentBlockingAppLoader />}
        </DetailsFrameBase>
    );
};
